<template>
  <div class="notification mb-3 bg-white shadow-sm rounded">
    <component :is="component" :entity="value.entity" :action="value.action"></component>
  </div>
</template>
<script>
import MydocGreeted from '@/components/Notification/Types/MydocGreeted'
import TreatmentItem from '@/components/Notification/Types/TreatmentItem'
import DeviceCheckup from '@/components/Notification/Types/DeviceCheckup'
import PatientCase from '@/components/Notification/Types/PatientCase'
import Diagnosis from '@/components/Notification/Types/Diagnosis'
import Schedule from '@/components/Notification/Types/Schedule'
export default {
  components: {
    MydocGreeted,
    DeviceCheckup,
    TreatmentItem,
    PatientCase,
    Diagnosis,
    Schedule
  },
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  computed: {
    component () {
      return this.value.entity_type || this.value.action
    }
  }
}
</script>
<style lang="scss">
// .notification {
//   box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
// }
</style>
